import React from 'react'
import Text, { DefaultFontProps } from 'library/atoms/Typography/Text'

const H5 = ({ children, ...other }: DefaultFontProps) => {
  return (
    <Text fontStyle="h5" as="h5" {...other}>
      {children}
    </Text>
  )
}

export default H5
